// extracted by mini-css-extract-plugin
export var box = "_7k-1";
export var checked = "_7k-2";
export var descriptionSpacer = "_7k-9";
export var disabled = "_7k-3";
export var icon = "_7k-6";
export var input = "_7k-0";
export var labelSpacer = "_7k-8";
export var medium = "_7k-5";
export var small = "_7k-4";
export var text = "_7k-7";